import styled from 'styled-components';
import { colors } from '@/globalStyles';

export const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-row-gap: 20px;
`;

export const NextModeWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
`;

export const NextModeItem = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: 22px 1fr;
  grid-column-gap: 13px;
  opacity: ${props => (props.$disabled ? 0.5 : 1)};
`;

export const Input = styled.input`
  width: 100%;
  padding: 0;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;

  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  margin: 0px;
  padding: 13px 15px;
  border-radius: 4px;
  background-color: ${colors.white};
  outline: none;
  border: none;
  
  &:hover {
    border: solid 1px ${colors.whiteSmoke};
  }

  &:focus {
    border: solid 1px ${colors.primary};
  }
`;

export const PanelHeaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 20px 1fr;
  grid-column-gap: 10px;
  align-items: center;
  cursor: pointer;
  padding: 5px 0;
  &:hover {
    * {
      fill: ${colors.primary};
    }
  }
`;

export const PanelHeader = styled.div`
  font-family: Lato;
  font-size: 14px;
  line-height: 18px;
`;

export const InputContainerWhite = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  height: 49px;
  max-height: 49px;
  font-weight: 400;
  border-radius: 4px;
  background-color: #ffffff;
  overflow: hidden;
`;

export const Icon = styled.img`
  cursor: pointer;
  width: 30px;
  height: 30px;
`;
